import { render } from "./ArticlePreview.vue?vue&type=template&id=90783e10&scoped=true"
import script from "./ArticlePreview.vue?vue&type=script&lang=js"
export * from "./ArticlePreview.vue?vue&type=script&lang=js"

import "./ArticlePreview.vue?vue&type=style&index=0&id=90783e10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90783e10"]])

export default __exports__